import React from 'react';
import cn from 'classnames';
import { navigate } from 'gatsby-link';
import {
  injectStripe,
  PaymentRequestButtonElement,
} from 'react-stripe-elements';

class ApplePay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rq: false,
      canMakePayment: null,
      localAmount: 0,
      loading: false,
    };
  }
  setPaymentRequest() {
    this.setState({ loading: true });
    const paymentRequest = this.props.stripe.paymentRequest({
      country: 'NZ',
      currency: 'nzd',
      total: {
        label: 'Donate to Everybody Eats',
        amount: this.props.amount * 100,
      },
      requestPayerName: true,
    });

    paymentRequest.on('token', ({ complete, token, ...data }) => {
      console.log('Received Stripe token: ', token);
      console.log('Received customer information: ', data);
      complete('success');

      fetch(`${process.env.GATSBY_LAMBDA_ENDPOINT}payment`, {
        method: 'POST',
        body: JSON.stringify({
          token,
          charge: {
            amount: this.state.localAmount * 100,
            currency: 'nzd',
            location: 'Onehunga',
          },
        }),
      })
        .then((response) => response.json())
        .catch((error) => console.error(error))
        .then((response) => {
          if (response !== undefined && response.hasOwnProperty('charge')) {
            navigate('/confirmation', {
              state: { amount: this.state.localAmount },
            });
          } else if (response) {
            this.setState({ error: response.error });
          }
        });
    });
    this.setState({ rq: paymentRequest, localAmount: this.props.amount });
    if (paymentRequest.canMakePayment) {
      paymentRequest.canMakePayment().then((result) => {
        console.log('canMakePayment', result);
        this.setState({ canMakePayment: result, loading: false });
      });
    }
  }
  componentDidUpdate() {
    if (this.state.rq && this.props.amount !== this.state.localAmount) {
      // condition 1 - check if amount confirmed with stripe matches input selected, if not hide paymentrequest
      this.setState({ rq: false, canMakePayment: null });
    }
    if (!this.state.rq && this.props.amount && !this.state.loading) {
      // condition 2 - if paymentrequest is not already avaliable and amount selected is greater than $0
      this.setPaymentRequest();
    }
  }

  render() {
    return this.state.canMakePayment != null && !this.state.loading ? (
      <div>
        <PaymentRequestButtonElement
          paymentRequest={this.state.rq}
          className="PaymentRequestButton"
          style={{
            paymentRequestButton: {
              type: 'donate',
              theme: 'light-outline',
              height: '41px',
            },
          }}
        />
        <p className={cn('mt-2 text-red', { hidden: !this.state.error })}>
          {this.state.error}
        </p>
      </div>
    ) : null;
  }
}
export default injectStripe(ApplePay);
